import React from 'react';
import Icon from '../../../components/AppIcon';

const TrailsHeader = ({ totalTrails, filteredCount, activeFilter }) => {
  const getFilterDisplayName = (filter) => {
    switch (filter) {
      case 'serbia':
        return 'Serbia';
      case 'montenegro':
        return 'Montenegro';
      default:
        return 'All Countries';
    }
  };

  return (
    <div className="text-center mb-12">
      <div className="max-w-3xl mx-auto">
        <h1 className="font-heading font-bold text-3xl md:text-4xl text-foreground mb-4">
          Discover Heritage Trails
        </h1>
        <p className="text-muted-foreground text-lg leading-relaxed mb-6">
          Explore eight unique thematic trails that connect cultural heritage sites, natural wonders, and authentic local experiences across Serbia and Montenegro. Each trail offers a carefully curated journey through centuries of history and breathtaking landscapes.
        </p>
        
        <div className="flex items-center justify-center gap-6 text-sm">
          <div className="flex items-center gap-2">
            <Icon name="MapPin" size={16} className="text-primary" />
            <span className="text-muted-foreground">
              Showing <span className="font-medium text-foreground">{filteredCount}</span> of {totalTrails} trails
            </span>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="Filter" size={16} className="text-primary" />
            <span className="text-muted-foreground">
              Filter: <span className="font-medium text-foreground">{getFilterDisplayName(activeFilter)}</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrailsHeader;